import React, { createContext, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/reducers/authSlice";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {

  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoggedIn,
        logout: handleLogout,
        loading: false
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}